import SiteUsersDataGrid from './SiteUsersDataGrid';

export default SiteUsersDataGrid;
